import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import truncate from 'truncate-markup-string';

import { Block as BlockEntity } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Block, Breadcrumbs, ParagraphsRenderer } from '../../../components';
import { NodeLandingPage as Type } from '../../../types/uncinc_profile/nodes';


interface LandingPageProps extends React.ComponentPropsWithoutRef<'article'> {
  entity: ImmutableEntity<Type>;
}

const NodeLandingPage: React.FC<LandingPageProps> = ({ entity, className, ...props }) => {
  const classes = classNames(className, 'NodeLandingPage');
  const node = entity.toJS();
  const heroTitle = node.title[0].value;
  const heroBody = node.body[0]?.processed;
  const paragraphs = node.field_paragraphs;
  const HERO_MAX_CHARS = 800;

  const contactFormBlockEntity = entity.getIn(['field_contact_form_block', 0, 'entity'], Immutable.Map());

  return (
    <article itemType="http://schema.org/WebPage" className={classes} {...props}>
      <Container>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-7">
            <h1>{heroTitle}</h1>
            {heroBody && (
              <div>
                <WysiwygField
                  className="body--large"
                  property="schema:text"
                  html={truncate(heroBody, HERO_MAX_CHARS, '<span>', '</span>', true)}
                />
              </div>
            )}
          </div>
        </div>
      </Container>

      <ParagraphsRenderer
        className="content-section mb-0"
        paragraphs={paragraphs}
        only={['map']}
        fluid
      />

      <Container>
        <div className="row">
          <div className="col-12 col-lg-7">
            <ParagraphsRenderer
              className="content-section"
              paragraphs={paragraphs}
              exclude={['map']}
            />
          </div>

          {node.field_block[0] && (
            <div className="col-lg-5 col-xl-4 offset-xl-1">
              <div className="content-section">
                <Block type="secondary">
                  <BlockEntity
                    entity={Immutable.fromJS(node.field_block[0]?.entity)}
                  />
                </Block>
              </div>
            </div>
          )}
        </div>

        {contactFormBlockEntity && (
          <BlockEntity entity={contactFormBlockEntity} />
        )}
      </Container>
    </article>
  );
};

export default NodeLandingPage;
